import {UserState} from './models/user';
import {LoaderState} from './models/loader/loader.redux';
import {AuthState} from './models/auth';
import {PanelUtilitiesState} from './models/panel-utilities';
import {ClinicState} from './models/clinic';
import {ClinicBranchState} from './models/clinic-branch';
import {ExpertState} from './models/expert';
import {PatientState} from './models/patient';
import {AppointmentState} from './models/appointment';
import {AppointmentIndicatorState} from './models/appointment-indicator';
import {ServiceState} from './models/service';
import {TimetableState} from './models/timetable';
import {PlanState} from './models/plan';
import {RefFoodTagsState} from './models/ref-food-tags/ref-food-tags.redux';
import {FoodGroupState} from './models/food-group';
import {IngredientState} from './models/ingredient';
import {MealPlanState} from './models/meal-plans';
import {MeasurementState} from './models/measurement';
import {NutritionalHistoryState} from './models/record-nutritional-history';
import {MedicalPersonalState} from './models/record-medical-personal';
import {MedicalInheritedFamilyDiseaseState} from './models/record-medical-inherited-family';
import {TourState} from './models/tour';
import {PatientSphereState} from './models/patient-sphere';
import {SpecializationState} from './models/specializations';
import {ExpertPublicProfileState} from './models/expert-public-profile';
import {OtherHabitsState} from './models/record-other-habits';
import {RecordPhysicalActivityState} from './models/record-physical-activity';
import {NutritionalPhysicalExaminationState} from './models/record-nutritional-physical-examination';
import {RecordEnvironmentAffectivityState} from './models/record-environment-affectivity';
import {DiseasesState} from './models/diseases';
import {RecordHistoryAttitudeState} from './models/record-history-attitude';
import {SleepState} from './models/record-sleep';
import {RecordHistoryBiochemistsState} from './models/record-history-biochemists';
import {RecordHistoryMyExperienceState} from './models/record-history-my-experience';
import {PatientGoalState} from './models/patient-goal';
import {PdfTemplateState} from './models/pdf-template';
import {StateClass} from '@ngxs/store/internals';
import {MealPlanBuilderState} from './models/meal-plan-builder';
import {MiniSphereState} from './models/record-mini-sphere/mini-sphere.redux';

export const NgxsStates: StateClass[] = [
  UserState,
  LoaderState,
  AuthState,
  PanelUtilitiesState,
  ClinicState,
  ClinicBranchState,
  ExpertState,
  PatientState,
  AppointmentState,
  AppointmentIndicatorState,
  ServiceState,
  TimetableState,
  PlanState,
  RefFoodTagsState,
  FoodGroupState,
  IngredientState,
  MealPlanState,
  MeasurementState,
  NutritionalHistoryState,
  MedicalPersonalState,
  MedicalInheritedFamilyDiseaseState,
  TourState,
  PatientSphereState,
  SpecializationState,
  ExpertPublicProfileState,
  OtherHabitsState,
  RecordPhysicalActivityState,
  NutritionalPhysicalExaminationState,
  RecordEnvironmentAffectivityState,
  DiseasesState,
  RecordHistoryAttitudeState,
  SleepState,
  RecordHistoryBiochemistsState,
  RecordHistoryMyExperienceState,
  PatientGoalState,
  PdfTemplateState,
  PdfTemplateState,
  MealPlanBuilderState,
  MiniSphereState
];
